<template>
    <div class="modal fade" id="add_update_restaurant_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="add_update_restaurant_modalLabel">Add / Update Restaurant: <b>{{restaurant.name}}</b></h4>
                </div>
                <form id="resAddForm" method="post" @submit.prevent="addUpdateRestaurant()" enctype="multipart/form-data">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Name</label>
                            <input v-model="restaurant.name" type="text" class="form-control" required="required" placeholder="Name..." :readonly="readOnly">
                        </div>
                        <div class="form-group">
                            <label>Website</label>
                            <input v-model="restaurant.website" type="text" class="form-control"  placeholder="Website..." :readonly="readOnly">
                        </div>
                        <div class="form-group">
                            <label>UAN</label>
                            <input v-model="restaurant.uan" required type="text" class="form-control" placeholder="UAN..." :readonly="readOnly">
                        </div>

                        <div class="form-group" v-if="userRole==='ADMIN'">
                            <label>Select Categories</label>
                          <multiselect v-if="options.length>0" v-model="categories" :options="options.map(type => type.id)" :custom-label="opt => options.find(x => x.id === opt).name" :multiple="true" :close-on-select="false"></multiselect>
                        </div>

                        <div class="form-group">
                            <label>Type</label>
                            <input v-model="restaurant.type" type="text" class="form-control" required="required" placeholder="Type..." :readonly="readOnly">
                        </div>
                        <div class="form-group">
                            <label>NTN</label>
                            <input v-model="restaurant.ntn" type="text" class="form-control" required="required" placeholder="NTN..." :readonly="readOnly" maxlength="255">
                        </div>
                        <div class="form-group">
                            <label>Post Card Picture</label><br/>
                            <img v-bind:src="restaurant.bigPicture" style="max-width: 30%" />
                            <input :disabled="readOnly" v-on:change="handlePicture('b')" type="file" class="form-control bigPic" placeholder="Type...">
                        </div>
                        <div class="form-group">
                            <label>Logo Picture</label><br/>
                            <img v-bind:src="restaurant.smallPicture" style="max-width: 20%" />
                            <input :disabled="readOnly" v-on:change="handlePicture('s')" type="file" class="form-control smallPic" placeholder="Type...">
                        </div>
                        <div v-if="userRole!=='USER' && userRole !=='FRANCHISE'">
                            <div class="checkbox">
                                <label>
                                    <input :disabled="readOnly" v-model="restaurant.onDeliveryMonster" type="checkbox"> Show on {{$store.getters.getValidPlatform}} App
                                </label>
                            </div>
                            <div class="checkbox">
                                <label>
                                    <input :disabled="readOnly" v-model="restaurant.onDeliveryMonsterHomePage" type="checkbox"> Featured on {{$store.getters.getValidPlatform}} App
                                </label>
                            </div>
                            <div class="checkbox">
                                <label>
                                    <input :disabled="readOnly" type="checkbox" v-model="restaurant.deleted"> Disabled
                                </label>
                            </div>
                            <div class="checkbox">
                                <label>
                                    <input :disabled="readOnly" type="checkbox" v-model="restaurant.smsEnabled"> SMS Enabled
                                </label>
                            </div>
                            <div class="checkbox">
                              <label>
                                <input :disabled="readOnly" type="checkbox" v-model="restaurant.popular"> Popular Restaurant
                              </label>
                            </div>
                          <div class="checkbox" v-if="restaurant.newRestaurant !== null">
                            <label>
                              <input :disabled="readOnly" type="checkbox" v-model="restaurant.newRestaurant"> New Restaurant
                            </label>
                          </div>
                            <div v-if="restaurant.smsEnabled">
                                <div class="checkbox" v-for="(value, key) in smsConfiguration" :key="key">
                                    <label>
                                        &emsp;<input :disabled="readOnly" type="checkbox" v-model="smsConfiguration[key]"> {{key.replaceAll(/_/g, ' ').toUpperCase()}}
                                    </label>
                                </div>
                            </div>
                            <hr>
                            <div class="form-group">
                                <label>Billing Name</label>
                                <input v-model="restaurant.billingName" type="text" class="form-control" placeholder="Billing Name" required :readonly="readOnly">
                            </div>
                            <div class="form-group">
                                <label>Billing Address</label>
                                <input v-model="restaurant.billingAddress" type="text" class="form-control" placeholder="Billing Address" :readonly="readOnly">
                            </div>
                            <div class="form-group">
                                <label>Billing Contact Number</label>
                                <input v-model="restaurant.billingContactNumber" type="text" class="form-control" placeholder="Billing Contact Number" :readonly="readOnly">
                            </div>
                            <div class="form-group">
                              <label>Billing Email Address</label>
                              <input v-model="restaurant.billingEmailAddress" type="email" class="form-control" placeholder="Billing Email Address" required :readonly="readOnly">
                            </div>
                            <div class="form-group" v-if="userRole!=='AGENT'">
                                <label>Profit Configuration (JSON)</label>
                                <div class="row">
                                    <div class="col-md-4">
                                        <input type="radio" :disabled="readOnly" v-model="profitType"  :value="0"> None
                                    </div>                                   
                                    <div class="col-md-4">
                                        <input type="radio" :disabled="readOnly"  v-model="profitType"  :value="1"> Commission
                                    </div>
                                    <div class="col-md-4">
                                        <input type="radio" :disabled="readOnly" v-model="profitType"  :value="2"> Fixed
                                    </div>                                                            
                                </div>
                                <br>
                                <div v-if="profitType===1 || profitType === 2">
                                    <div class="row"  v-for="(priceConfig, index) in profitConfiguration.priceWiseProfit" :key="index" style="margin-bottom: 10px">
                                        <div class="col-md-4">
                                            <input v-model="priceConfig.from" type="number" class="form-control" placeholder="From" min="0">
                                        </div>
                                        <div class="col-md-4">
                                            <input v-model="priceConfig.to" type="number" class="form-control" placeholder="To" min="0" max="99999">
                                        </div>
                                        <div class="col-md-3">
                                            <input v-model="priceConfig.profit" type="number" class="form-control" placeholder="Profit" min="0" step="any">
                                        </div>
                                        <div class="col-md-1">
                                            <button class="btn btn-danger btn-md" type="button" :disabled="readOnly" @click="removeConfig(index)"><i class="fa fa-times"></i></button>
                                        </div>
                                    </div>
                                </div>
                                    <div class="row" v-if="profitType===1 || profitType === 2">
                                        <div class="col-md-12">
                                            <button class="btn btn-primary" type="button" :disabled="readOnly" @click="addNewConfig()">Add Order Amount</button>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button :disabled="readOnly" type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button :disabled="readOnly" type="submit" class="btn btn-primary">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    import Multiselect from 'vue-multiselect'
    export default {
        components: { Multiselect },
        name: "AddUpdateRestaurant",
        data() {
            return {
                restaurant: {
                    "id": 0,
                    "name": "",
                    "uan": "",
                    "website": "",
                    "profitConfigurations": "",
                    "type": "",
                    "ntn": "",
                    "deleted": false,
                    "popular": false,
                    "categories":"",
                    "smallPicture": "",
                    "bigPicture": "",
                    "onDeliveryMonster": false,
                    "onDeliveryMonsterHomePage": false,
                    "smsEnabled": false,
                    "smsConfiguration": null,
                    "billingName": null,
                    "billingAddress": null,
                    "billingContactNumber":null,
                    "billingEmailAddress": null,
                    "newRestaurant": false,
                    "markedNewOn": null,
                },
                categories: null,
                options: [],
                smallPic: null,
                bigPic: null,
                readOnly:false,
                userRole:'',
                profitType: 0,
                profitConfiguration:{
                    fixedProfit: false,
                    percent: true,
                    priceWiseProfit:[{from:'', to:'', profit:''}],
                },
                smsConfiguration:{
                    accepted_by_branch:0,
                    ready_for_delivery:0,
                    ready_for_pickup:0,
                    feedback:0
                }
            }
        },
        computed: {
          hideIsNewOption() {
            return !this.restaurant.newRestaurant && this.restaurant.markedNewOn !== null;
          },
          isDVMPortal() {
            return this.$store.getters.isDVMportal
          }
        },
        watch: {
            profitType: function(){
                if(this.profitType===1){ //commision
                    this.profitConfiguration.fixedProfit= false;
                    this.profitConfiguration.percent= true;
                }else{ //fixed
                    this.profitConfiguration.fixedProfit= true;
                    this.profitConfiguration.percent= false;                    
                }
            },
        },
        mounted: function () {
            $('#add_update_restaurant_modal').on('hidden.bs.modal',  (e) => {
                if(this.$parent.dtTable !== undefined && this.$parent.dtTable !== null){
                    this.$parent.dtTable.draw();
                }
                this.resetData();
            });
        },
        methods: {
            load: function (restaurantId){
                this.userRole= this.$store.state.user.userRolesById[0].role.split('_')[1]
                if(this.userRole==='AGENT' || this.userRole==='MANAGER'){
                    this.readOnly=true;
                }
                if(restaurantId > 0){
                    let params = new URLSearchParams();
                    params.append("restaurant_id", restaurantId);
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_restaurant_by_id", params).then(resp => {
                       this.restaurant = resp.data;
                       this.categories = JSON.parse(this.restaurant.categories);
                       if(this.restaurant.profitConfigurations!==""){
                           this.profitConfiguration= JSON.parse(this.restaurant.profitConfigurations);
                           if(this.profitConfiguration.percent===true){
                               this.profitType=1;
                           }else if(this.profitConfiguration.fixedProfit===true){
                               this.profitType=2;
                           }else{
                               this.profitType=0;
                           }
                       }
                        if(this.restaurant.smsConfiguration!==null){
                            this.smsConfiguration= JSON.parse(this.restaurant.smsConfiguration);
                        }
                    });
                }
                this.$http.get(this.$store.state.mainAppURL + "restaurant_categories/").then(resp => {
                  this.options = resp.data;
                });
                $("#add_update_restaurant_modal").modal("show");
            },
            handlePicture: function(type) {
                let input = (type === 'b') ? $(".bigPic") : $(".smallPic");
                if (input.prop('files')[0] !== undefined) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        input.prev().attr('src', e.target.result);
                    };
                    reader.readAsDataURL(input.prop('files')[0]);
                    if(type === 'b'){
                        this.bigPic = input.prop('files')[0];
                    }else{
                        this.smallPic = input.prop('files')[0];
                    }
                }else{
                    input.prev().attr('src', "");
                }
            },
            addUpdateRestaurant: function () {
                this.restaurant.categories = JSON.stringify(this.categories);
                if(this.profitType===1 || this.profitType === 2){
                    for(let profit of this.profitConfiguration.priceWiseProfit){
                        if(profit.from==='' || profit.to==='' || profit.profit===''){
                            swal('Error', 'Profit Configuration Cannot Be Empty', 'error');
                            return;
                        }
                    }
                }
                if(this.profitType===0){
                    this.restaurant.profitConfigurations= '';
                }
                if(this.profitType!==0){
                    this.restaurant.profitConfigurations= JSON.stringify(this.profitConfiguration);
                }
                if(this.restaurant.smsEnabled){
                    this.restaurant.smsConfiguration= JSON.stringify(this.smsConfiguration);
                }
                if (this.restaurant.newRestaurant) {
                  this.restaurant.markedNewOn = new Date().toISOString()
                }
                let formData = new FormData();
                if (this.isDVMPortal) {
                  delete this.restaurant.city
                }
                formData.append("restaurant", JSON.stringify(this.restaurant));
                formData.append("bigPic", this.bigPic);
                formData.append("smallPic", this.smallPic);
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                this.$http.post( this.$store.state.mainAppURL + "restaurants/add_update_restaurant",
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data;'
                        }
                    }
                ).then((resp) => {
                    console.log(resp);
                    Swal.close();
                   if(resp.data){
                       $("#add_update_restaurant_modal").modal("hide");
                   }else{
                       swal("Error!" ," Please Try Again", "error");
                   }
                }).catch((ex) => {
                  this.showErrorMessage(ex)
                });
            },
            resetData: function () {
                Object.assign(this.$data, this.$options.data.call(this));
                $("input[type=file]").val("");
                $(".bigPic").prev().attr("src", "");
                $(".smallPic").prev().attr("src", "");
            },
            addNewConfig: function() {
                let newPriceWiseProfit={
                        from:'',
                        to:'',
                        profit:''
                     };
                     this.profitConfiguration.priceWiseProfit.push(newPriceWiseProfit);
            },
            removeConfig: function(index){
                if(this.profitConfiguration.priceWiseProfit.length===1){
                    swal('Error', 'Need At Least One Configuration', 'error');
                    return false;                    
                }
                this.profitConfiguration.priceWiseProfit.splice(index, 1);

            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
